export default {
  fields: {
    discount: {
      label: 'Sconto',
    },
    usage_threshold: {
      label: 'Importo minimo ordine',
    },
    max_discount: {
      label: 'Importo massimo sconto',
    },
  },
};
